import { useHistory } from "react-router-dom";
import React, { ReactNode, useContext, useEffect, useState } from "react";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog/ConfirmationDialog";
import { TestRequestTabType } from "../../Requests/useTestRequestParams";
import DeepLink from "../../../components/DeepLink";
import TestRequestApi from "../../../api/services/TestRequestApi";
import useEnv from "../../../hooks/env";
import CustomProgress from "../../../components/Alert/CustomProgress";
import { tesaBlue } from "../../../styles/colors";
import ErrorSnackbarContext from "../../../contexts/ErrorSnackbarContext";

type RequestState = "LOADING" | "SUCCESS" | "ERROR";

export interface AddToFurtherInternalContactDialogProps {
  testRequestId: string;
}

const AddToFurtherInternalContactDialog: React.FC<AddToFurtherInternalContactDialogProps> = (props) => {
  const { api } = useEnv();
  const history = useHistory();
  const testRequestApi = new TestRequestApi(api);

  const { testRequestId } = props;

  const { handleHttpError } = useContext(ErrorSnackbarContext);

  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [requestState, setRequestState] = useState<RequestState>("LOADING");

  useEffect(() => {
    testRequestApi
      .updateFurtherInternalContacts(testRequestId)
      .then(() => setRequestState("SUCCESS"))
      .catch((error) => {
        handleHttpError(error);
        setRequestState("ERROR");
      });
  }, []);

  const renderText = (): ReactNode => {
    switch (requestState) {
      case "LOADING":
        return <CustomProgress />;
      case "SUCCESS":
        return (
          <>
            <span>You were added to further internal contacts for the test request </span>
            <DeepLink
              label={testRequestId}
              pathParams={{
                requestId: testRequestId,
                tab: TestRequestTabType.REPORT,
              }}
            />
          </>
        );
      case "ERROR":
        return (
          <span>
            You can not be added as internal contact for the test request {testRequestId}. For further information
            please contact your local CSC lab manager.
          </span>
        );
      default:
        return "";
    }
  };

  return (
    <ConfirmationDialog
      headline="Further Internal Contact"
      text={renderText()}
      open={isOpen}
      onCancel={() => {}}
      confirmText="Close"
      onConfirm={(id) => {
        if (id === "TESTREQUEST") {
          history.push(`/requests/${testRequestId}/${TestRequestTabType.REPORT}`);
        }
        setIsOpen(false);
      }}
      hideCancel
      additionalAction={
        requestState === "SUCCESS"
          ? {
              id: "TESTREQUEST",
              text: "Go to test request",
              textColor: tesaBlue,
            }
          : undefined
      }
    />
  );
};

export default AddToFurtherInternalContactDialog;
